import React from 'react';
import EditDescriptionDialog from './EditDescriptionDialog';
import trackAnalytics from '../../utils/gaia/trackAnalytics';

export default class FlagButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: false,
            flagged: props.flagged,
            flagged_note: props.flaggedNote,
        };
    }

    render() {
        return (
            <span>
                <a
                    style={{color: '#E66045'}}
                    href="#"
                    title="Flag This"
                    onClick={e => { e.preventDefault(); this.toggleState(); }}
                >
                    <i className="material-icons ibmid">flag</i>
                    <span className="ibmid">
                        {this.state.flagged ? 'FLAGGED - View Note' : 'Flag'}
                    </span>
                </a>
                <EditDescriptionDialog
                    afterUpdate={desc => this.updateFlagButton(desc)}
                    apiEndpoint={'flag'}
                    // eslint-disable-next-line max-len
                    hint={'Add a note about why you are flagging this. To remove the flag, delete the text and save.'}
                    regionType={this.props.regionType}
                    onRequestClose={() => this.toggleState()}
                    open={this.state.dialogOpen}
                    originalDescription={this.props.flaggedNote}
                    regionId={this.props.regionId}
                    text={this.props.flaggedNote}
                    title={'Edit Flag Note'}
                />
            </span>
        );
    }

    toggleState() {
        this.setState({dialogOpen: !this.state.dialogOpen});
        if (this.state.dialogOpen) {
            trackAnalytics('Flag Button', {
                category: 'Hike',
                regionId: this.props.regionId,
                regionType: this.props.regionType,
                path: window.location.pathname,
            });
        }
    }

    updateFlagButton(desc) {
        this.setState({
            flagged: desc && desc.length > 0,
            flaggedNote: this.props.flaggedNote,
        });
    }

}
